export const integrations_index = ['integrations.index']
export const integrations_create = ['integrations.create']
export const integrations_edit = ['integrations.edit']

export default [].concat(
    integrations_index,
    integrations_create,
    integrations_edit
)
